export default __webpack_public_path__ + "static/media/8673.056d1001.jpg";